import React from "react";
import { Doughnut } from "react-chartjs-2";

import "chart.js/auto";
import { Chart, CategoryScale } from "chart.js";
Chart.register(CategoryScale);

const DountChart = () => {
  const data = {
    labels: ["Active", "Idle", "In Fault", "Others"],

    datasets: [
      {
        data: [21, 16, 48, 31],
        backgroundColor: ["#11c46e", "#3d8ef8", "#FF3D60", "#7c8a96"],
        borderColor: ["#11c46e", "#3d8ef8", "#FF3D60", "#7c8a96"],
      },
    ],
  };

  const option = {
    responsive: true,
    cutoutPercentage: 70,
    animation: {
      animateScale: true,
      animateRotate: true,
    },

    plugins: {
      legend: {
        position: "bottom", // Adjust legend position if needed
      },
    },
  };

  return (
    <React.Fragment>
      <Doughnut
        width={500}
        height={500}
        data={data}
        options={option}
        className="chartjs-chart"
      />
    </React.Fragment>
  );
};

export default DountChart;
